// src/pages/MatrikaHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const MatrikaHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Digital Income");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Digital Income", emoji: "💰" },
    { label: "Digital Learning", emoji: "💡" },
    { label: "Task & Management", emoji: "🗂️" },
    { label: "Self Reflection", emoji: "🪞" },
    { label: "Matrika Shopping", emoji: "🛍️" },
    { label: "CareWorld", emoji: "💚" },
    { label: "Community & Social", emoji: "🤝" },
    { label: "Recognition & Progress", emoji: "🏅" },
    { label: "Wishes & Fun", emoji: "🎬" },
    { label: "Matrika Mandi", emoji: "🔆" },
    { label: "Products by Women", emoji: "🌟" },
  ];

  const menuButtons1 = [
    // 💡 DIGITAL LEARNING
    { label: "My Immersive Digital Books", emoji: "📚", link: "/bookshelf", group: "Digital Learning" },
    { label: "Matrika Digital Books", emoji: "📖", link: "/matrika-bookworld", group: "Digital Learning" },
    { label: "Matrika Shorts", emoji: "🎬", link: "/litenshort", group: "Digital Learning" },
    { label: "Matrika Workshops", emoji: "🎓", link: "/sheearns-trainingworkshop", group: "Digital Learning" },
    { label: "Matrika Podcast", emoji: "🎙️", link: "/podcast-mylist", group: "Digital Learning" },

    // 💰 DIGITAL INCOME
    { label: "ValueShare", emoji: "💱", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "My Income", emoji: "💰", link: "/sheearns-income", group: "Digital Income" },
    { label: "Introduce User", emoji: "👥📢", link: "/sheearns-introduce", group: "Digital Income" },
    { label: "Digital Boutique", emoji: "🛍️💻", link: "/digiboutique", group: "Digital Income" },
    { label: "Kharcho Jeeto", emoji: "🛒🎁", link: "/kharchojeeto", group: "Digital Income" },
    { label: "Marksheet Contest", emoji: "📜🏆", link: "/applause-marksheet-contest", group: "Digital Income" },
    { label: "Rewarding Cooking", emoji: "🍳💰", link: "/sheearns-rewardingcooking", group: "Digital Income" },
    { label: "Rewarding Ads", emoji: "📺💎", link: "/visigift-home", group: "Digital Income" },
    { label: "Rewarding Videos", emoji: "🎥💰", link: "/orderflow-spotbuy", group: "Digital Income" },
    { label: "Business Funding", emoji: "💼💳", link: "/fundlanes", group: "Digital Income" },

    // 🗂️ TASK & MANAGEMENT
    { label: "Matrika Daily", emoji: "📝", link: "/sheearns-daily", group: "Task & Management" },
    { label: "Diary", emoji: "📔", link: "/mydiary-home", group: "Task & Management" },
    { label: "Health & Wellness", emoji: "💚", link: "/sheearns-health", group: "Task & Management" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Task & Management" },
    { label: "Goal Board", emoji: "🎯", link: "/sheearns-goalboard", group: "Task & Management" },
    { label: "Kanban", emoji: "📊", link: "/sheearns-kanban", group: "Task & Management" },
    { label: "Digital Writing Paper", emoji: "✍️📄", link: "/sheearns-touchbookplain", group: "Task & Management" },
    { label: "Digital Writing Grid", emoji: "✍️📊", link: "/sheearns-touchbookgrid", group: "Task & Management" },
    { label: "Digital Voice Writing", emoji: "🎙️✍️", link: "/sheearns-voicebook", group: "Task & Management" },
    { label: "Tindi", emoji: "🚗🚌🚆", link: "/tindi", group: "Task & Management" },

    // 🛍️ SHAKTI SHOPPING
    { label: "My Orders", emoji: "📦", link: "/myprofile-myorders", group: "Matrika Shopping" },
    { label: "Home Basket", emoji: "🏡🛒", link: "/createmyvegbasket", group: "Matrika Shopping" },
    { label: "Matrika Mandi Basket", emoji: "🛒🏡", link: "/catalogue/mahilamandi", group: "Matrika Shopping" },
    { label: "Personal Shopping", emoji: "👜💃", link: "/orderflow-home", group: "Matrika Shopping" },
    { label: "Family Shopping", emoji: "👨‍👩‍👧‍👦🛒", link: "/orderflow-home", group: "Matrika Shopping" },
    { label: "GaonSe", emoji: "👨‍👩‍👧‍👦🛒", link: "/gaonse", group: "Matrika Shopping" },
    { label: "Matrika Mandi Nearby Deals", emoji: "📍🛍️", link: "/mahilamandi-nearbydeals", group: "Matrika Shopping" },
    { label: "Juhi", emoji: "🌸💅", link: "/juhi", group: "Matrika Shopping" },
    { label: "Bhojan", emoji: "🍱🍛", link: "/bhojan", group: "Matrika Shopping" },
    { label: "Ratnavya", emoji: "💎✨", link: "/ratnavya", group: "Matrika Shopping" },
    { label: "Gift", emoji: "🎁💖", link: "/giftify", group: "Matrika Shopping" },
    { label: "RoomAnywhere", emoji: "🏠🌍", link: "/roomanywhere", group: "Matrika Shopping" },
    { label: "ThinkStylus", emoji: "🖊️💡", link: "/thinkstylus", group: "Matrika Shopping" },
    { label: "MADSmania", emoji: "📄🔁🎨", link: "/madsmania-home", group: "Matrika Shopping" },
    { label: "DSeven", emoji: "🧩7️⃣🌈", link: "/dseven", group: "Matrika Shopping" },
    { label: "Digital Tryout", emoji: "🪄💻", link: "/digitaltryout", group: "Matrika Shopping" },
    { label: "Window Shopping", emoji: "🏬👀", link: "/twiworld", group: "Matrika Shopping" },

    // 🌸 MatrikaMandi
    { label: "I Have Product to Sell", emoji: "🙋‍♀️🧵", link: "/mlmproductrequest/add", group: "Matrika Mandi" },
    { label: "GaonSe", emoji: "👨‍👩‍👧‍👦🛒", link: "/gaonse", group: "Matrika Mandi" },
    { label: "Mandi Basket", emoji: "🧺🤝", link: "/mahilamandi-createbasket", group: "Matrika Mandi" },
    { label: "Mandi Padoss", emoji: "📍🏘️", link: "/mahilamandi-nearbydeals", group: "Matrika Mandi" },
    { label: "Contract Manufacturing", emoji: "🤝🏭", link: "/mahilamandi-contractmfg", group: "Matrika Mandi" },
    { label: "Unity Deal s", emoji: "🛒🤗", link: "/mahilamandi-unitydeals", group: "Matrika Mandi" },
    { label: "Quick Delivery", emoji: "⚡🚚", link: "/mahilamandi-xpresshome", group: "Matrika Mandi" },
    { label: "View Material Live", emoji: "🏬👀", link: "/twiworld", group: "Matrika Mandi" },
    { label: "Matrika Grih Seva", emoji: "🏠🤲👩‍🍳", link: "/digiboutique", group: "Matrika Mandi" },
    { label: "Enquiry", emoji: "📩❓", link: "/mahilamandi-leads", group: "Matrika Mandi" },
    { label: "Complaints", emoji: "⚠️📢", link: "/mahilamandi-complaints", group: "Matrika Mandi" },
    { label: "Digital Boutique Rozgar", emoji: "💻💪👩‍💼", link: "/digiboutique", group: "Matrika Mandi" },
    { label: "Mandi Weekly", emoji: "📰", link: "/mahilamandi-weekly", group: "Matrika Mandi" },

    // 🪞 SHELF REFLECTION
    { label: "My Pink Card", emoji: "💖", link: "/digitalshakticard", group: "Self Reflection" },
    { label: "My Memories", emoji: "📸", link: "/memories-list", group: "Self Reflection" },
    { label: "Grihani", emoji: "🏡", link: "/grihani", group: "Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️", link: "/sheearns-focustimerstart", group: "Self Reflection" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Self Reflection" },
    { label: "Matrika AI Counselling", emoji: "🧠", link: "/aicounselling", group: "Self Reflection" },
    { label: "Motherhood Journey", emoji: "🤱", link: "/sheearns-motherhood", group: "Self Reflection" },
    { label: "Personal Lifestages", emoji: "🌱", link: "/myprofile-lifestages", group: "Self Reflection" },  
    // { label: "Pre-Schooler MATRIKA", emoji: "👩‍👩‍👧", link: "/matrika", group: "Self Reflection" },
    // { label: "My Jugaad / Hack", emoji: "🧱", link: "/jugaad", group: "Self Reflection" },
    { label: "My Think5Whys Profile", emoji: "🧱", link: "/sheearns-profilehome", group: "Self Reflection" },

    // 🤝 COMMUNITY & SOCIAL
    { label: "SAKSHAM Matrika Events", emoji: "📅🎉", link: "/event-flow-home", group: "Community & Social" },
    { label: "Applause", emoji: "👏", link: "/applause-hub-home", group: "Community & Social" },
    { label: "Green Matrika", emoji: "🌱", link: "/coolearth-home", group: "Community & Social" },
    { label: "Responsible Indian", emoji: "🌏", link: "/rim", group: "Community & Social" },
    { label: "Community Jugaad / Hack", emoji: "🧱👥", link: "/jugaad", group: "Community & Social" },
    { label: "Matrika Presentation", emoji: "📊", link: "/visualbrief-home", group: "Community & Social" },
    { label: "Matrika Forum", emoji: "🗣️", link: "/povify-home", group: "Community & Social" },
    { label: "BoloGrahak", emoji: "🙋‍♀️", link: "/bolograhak", group: "Community & Social" },
    { label: "Matrika2Farmers", emoji: "👩‍🌾", link: "/mykisan", group: "Community & Social" },

    // 🏅 RECOGNITION & PROGRESS
    { label: "Matrika Ranking", emoji: "🏆", link: "/sakshamshaktiscore", group: "Recognition & Progress" },
    { label: "Self Applause", emoji: "👏", link: "/self-applause", group: "Recognition & Progress" },
    { label: "I Was Appreciated", emoji: "👏", link: "/applause-for-me", group: "Recognition & Progress" },
    { label: "SAKSHAM Matrika Database", emoji: "🗄️", link: "/sheearnsdb", group: "Recognition & Progress" },
    { label: "Matrika Innovations", emoji: "💡", link: "/sheearns-innovationhub", group: "Recognition & Progress" },

    // 🎬 Wishes & Fun
    { label: "wTube", emoji: "▶️", link: "/wtube", group: "Wishes & Fun" },
    { label: "Clap4Service", emoji: "👏", link: "/clap4service", group: "Wishes & Fun" },
    { label: "Matrika Wishes", emoji: "🌈", link: "/sheearns-wishes", group: "Wishes & Fun" },
    { label: "Matrika Games", emoji: "🎮", link: "/sheearns-games", group: "Wishes & Fun" },
    { label: "SpotSnap", emoji: "🖼️", link: "/spotsnap", group: "Wishes & Fun" },
    { label: "Aalu Dalo Sona Nikalo", emoji: "🥔💰", link: "/aaludalosonanikalocomingsoon", group: "Wishes & Fun" },

    // 💚 CareWorld
    { label: "CareWorld", emoji: "💚", link: "/careworld", group: "CareWorld" },
    { label: "Daily Care Log", emoji: "📝", link: "/sheearns-daily", group: "CareWorld" },
    { label: "Care Diary", emoji: "📔", link: "/mydiary-home", group: "CareWorld" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "CareWorld" },
    { label: "Daily Goal Board", emoji: "🎯", link: "/sheearns-goalboard", group: "CareWorld" },
    { label: "Daily Kanban", emoji: "📊", link: "/sheearns-kanban", group: "CareWorld" },
    { label: "Digital Writing Paper", emoji: "✍️📄", link: "/sheearns-touchbookplain", group: "CareWorld" },

    // 🌟 SakshamSHGProducts
    { label: "VIBHA", emoji: "🌟", link: "/sakshamshg-products", group: "Products by Women" },
    { label: "RITU", emoji: "🌟", link: "/sakshamshg-products", group: "Products by Women" },
    { label: "KHUSHI", emoji: "🌟", link: "/sakshamshg-products", group: "Products by Women" },
    { label: "BABITA", emoji: "🌟", link: "/sakshamshg-products", group: "Products by Women" },
    { label: "Gudia", emoji: "🌟", link: "/sakshamshg-products", group: "Products by Women" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-[#1a0b1e] text-pink-100 font-sans">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-pink-400">👩‍👧‍👦 Matrika</div>
          <div className="text-[10px] lg:text-lg text-yellow-200">
            Matrika: Care with Best Home Management!
          </div>
        </div>

        {/* Desktop user controls */}
        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-left text-pink-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 mt-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-pink-700 text-sm text-pink-200 hover:bg-pink-900"
              >
                Login
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-pink-300 bg-pink-500"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-row items-center justify-center gap-3">
              <span className="text-pink-300 text-xs font-medium whitespace-nowrap h-7">
                {userName}
              </span>
              <button
                onClick={handleLogout}
                className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-6">
              <Link to="/login" className="text-pink-300 hover:text-yellow-300">
                Login
              </Link>
            </div>
          )}
        </div>
      )}

      {/* Top quick links */}
      <div className="bg-pink-900/40 text-white text-xs sm:text-sm py-2 mt-2">
        <div className="max-w-6xl mx-auto px-3 flex flex-wrap justify-center gap-2 text-m lg:text-lg">
          <a href="/matrika-insights" className="hover:text-yellow-200">💭 About</a>
          <a href="/rim" className="hover:text-yellow-300">🌏 RIM</a>
          <Link to="/litenshort" className="hover:text-yellow-200">🗞️ Short News</Link>
          <a href="/matrika-updates" className="hover:text-yellow-200">📊 Updates</a>
          <a href="/matrika-faq" className="hover:text-yellow-200">🤔 FAQ</a>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>
        </div>
        <div className="text-[12px] lg:text-lg text-center my-1 mx-1 mt-2  text-pink-200/90">
           Extending Digital Empowerment for Indian Women to Support Continuous Income, Learning & Productivity!
        </div>
        <div className="mt-3 flex flex-wrap justify-center gap-3 text-sm text-blue-500">
          <Link to="/think5whysistrusted" className="text-yellow-200 hover:text-yellow-300 text-[12px] lg:text-lg">
            🔒 Trusted & Secure Platform – ISO 9001, ISO 27001, SOC-2 Certified
          </Link>        
        </div>
      </div>

      {/* Tabs */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-pink-700">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-2 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs lg:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-purple-700 text-yellow-200 shadow-md"
                  : "bg-pink-800 text-pink-100 hover:bg-pink-900"
              }`}
            >
              <span className="text-xl">{group.emoji}</span>
              <span className="mt-1 text-m text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main grid */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-pink-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-[14px] text-xs lg:text-sm font-medium transition bg-transparent hover:bg-pink-700 hover:text-yellow-200 text-pink-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-xl lg:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-pink-800 text-pink-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );

};

export default MatrikaHome;


  